(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["getsnappy-body-benefits"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (!window.customElements || customElements.get('gs-silicone-benefits')) return;
    customElements.define('gs-silicone-benefits', class extends HTMLElement {
      connectedCallback() {
        if (this._gsBenefitsReady) return;
        const initialize = () => {
          if (!this.isConnected || this._gsBenefitsReady) return;
          this.track = this.querySelector('.gs-silicone-benefits__track');
          if (!this.track) return;
          this.cards = [...this.querySelectorAll('.gs-silicone-benefits__card')];
          this.previous = this.querySelector('[data-gs-benefits-prev]');
          this.next = this.querySelector('[data-gs-benefits-next]');
          this.count = this.querySelector('.gs-silicone-benefits__count');
          this.controls = this.querySelector('.gs-silicone-benefits__controls');
          if (!this.cards.length || !this.previous || !this.next || !this.controls) return;
          this._gsBenefitsReady = true;
          this.abort = new AbortController();
          const options = { signal: this.abort.signal };
          this.previous.addEventListener('click', () => this.move(-1), options);
          this.next.addEventListener('click', () => this.move(1), options);
          this.track.addEventListener('keydown', event => {
            if (event.target !== this.track || event.altKey || event.ctrlKey || event.metaKey) return;
            if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
            event.preventDefault();
            const rtl = getComputedStyle(this.track).direction === 'rtl';
            if (event.key === 'Home' || event.key === 'End') {
              this.track.scrollTo({ left: event.key === 'Home' ? 0 : (rtl ? -1 : 1) * this.track.scrollWidth, behavior: this.motion() });
            } else {
              this.move((event.key === 'ArrowRight' ? 1 : -1) * (rtl ? -1 : 1));
            }
          }, options);
          this.addEventListener('shopify:block:select', event => {
            const card = this.cards.find(item => item.dataset.blockId === event.detail?.blockId);
            card?.scrollIntoView({ block: 'nearest', inline: 'start', behavior: 'auto' });
          }, options);
          this.track.addEventListener('scroll', () => this.scheduleUpdate(), { ...options, passive: true });
          if (window.ResizeObserver) {
            this.observer = new ResizeObserver(() => this.scheduleUpdate());
            this.observer.observe(this.track);
          } else {
            window.addEventListener('resize', () => this.scheduleUpdate(), options);
          }
          this.update();
        };
        // A section may be inserted or moved by the Shopify theme editor.
        // Wait for the element's children if this definition was registered earlier.
        this._gsBenefitsInit = requestAnimationFrame(initialize);
      }
      disconnectedCallback() {
        cancelAnimationFrame(this._gsBenefitsInit);
        cancelAnimationFrame(this._gsBenefitsFrame);
        this.abort?.abort();
        this.observer?.disconnect();
        this._gsBenefitsReady = false;
      }
      motion() {
        return window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      }
      move(direction) {
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const step = this.cards[0].getBoundingClientRect().width + gap;
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        this.track.scrollBy({ left: direction * step * (rtl ? -1 : 1), behavior: this.motion() });
      }
      scheduleUpdate() {
        cancelAnimationFrame(this._gsBenefitsFrame);
        this._gsBenefitsFrame = requestAnimationFrame(() => this.update());
      }
      update() {
        const maximum = this.track.scrollWidth - this.track.clientWidth;
        const position = Math.abs(this.track.scrollLeft);
        this.querySelector('.gs-silicone-benefits__footer').hidden = maximum < 2;
        this.controls.hidden = this.dataset.showArrows !== 'true' || maximum < 2;
        this.previous.disabled = position <= 2;
        this.next.disabled = position >= maximum - 2;
        const viewport = this.track.getBoundingClientRect();
        const visible = this.cards.map((card, index) => {
          const rect = card.getBoundingClientRect();
          const middle = rect.left + rect.width / 2;
          return middle >= viewport.left && middle <= viewport.right ? index + 1 : null;
        }).filter(Boolean);
        if (this.count && visible.length) {
          const first = visible[0];
          const last = visible[visible.length - 1];
          this.count.textContent = `${first === last ? first : first + '–' + last} of ${this.cards.length}`;
        }
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["getsnappy-faq"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (!window.customElements || customElements.get('gs-silicone-faq')) return;
    customElements.define('gs-silicone-faq', class extends HTMLElement {
      connectedCallback() {
        if (!window.Shopify?.designMode || this._gsFaqAbort) return;
        this._gsFaqAbort = new AbortController();
        this.addEventListener('shopify:block:select', event => {
          const item = [...this.querySelectorAll('.gs-silicone-faq__item')].find(faq => faq.dataset.blockId === event.detail?.blockId);
          if (!item) return;
          item.open = true;
          item.scrollIntoView({ block: 'nearest', behavior: 'auto' });
        }, { signal: this._gsFaqAbort.signal });
      }
      disconnectedCallback() {
        this._gsFaqAbort?.abort();
        this._gsFaqAbort = null;
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["getsnappy-how-to-use"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (!window.customElements || customElements.get('gs-silicone-howto')) return;
    customElements.define('gs-silicone-howto', class extends HTMLElement {
      connectedCallback() {
        if (this._gsHowtoReady) return;
        const initialize = () => {
          if (!this.isConnected || this._gsHowtoReady) return;
          this.track = this.querySelector('.gs-silicone-howto__track');
          if (!this.track) return;
          this.cards = [...this.querySelectorAll('.gs-silicone-howto__card')];
          this.previous = this.querySelector('[data-gs-howto-prev]');
          this.next = this.querySelector('[data-gs-howto-next]');
          this.count = this.querySelector('.gs-silicone-howto__count');
          this.controls = this.querySelector('.gs-silicone-howto__controls');
          if (!this.cards.length || !this.previous || !this.next || !this.controls) return;
          this._gsHowtoReady = true;
          this.abort = new AbortController();
          const options = { signal: this.abort.signal };
          this.previous.addEventListener('click', () => this.move(-1), options);
          this.next.addEventListener('click', () => this.move(1), options);
          this.track.addEventListener('keydown', event => {
            if (event.target !== this.track || event.altKey || event.ctrlKey || event.metaKey) return;
            if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
            event.preventDefault();
            const rtl = getComputedStyle(this.track).direction === 'rtl';
            if (event.key === 'Home' || event.key === 'End') {
              this.track.scrollTo({ left: event.key === 'Home' ? 0 : (rtl ? -1 : 1) * this.track.scrollWidth, behavior: this.motion() });
            } else {
              this.move((event.key === 'ArrowRight' ? 1 : -1) * (rtl ? -1 : 1));
            }
          }, options);
          this.addEventListener('shopify:block:select', event => {
            const card = this.cards.find(item => item.dataset.blockId === event.detail?.blockId);
            card?.scrollIntoView({ block: 'nearest', inline: 'start', behavior: 'auto' });
          }, options);
          this.track.addEventListener('scroll', () => this.scheduleUpdate(), { ...options, passive: true });
          if (window.ResizeObserver) {
            this.observer = new ResizeObserver(() => this.scheduleUpdate());
            this.observer.observe(this.track);
          } else {
            window.addEventListener('resize', () => this.scheduleUpdate(), options);
          }
          this.update();
        };
        // A section may be inserted or moved by the Shopify theme editor.
        // Wait for the element's children if this definition was registered earlier.
        this._gsHowtoInit = requestAnimationFrame(initialize);
      }
      disconnectedCallback() {
        cancelAnimationFrame(this._gsHowtoInit);
        cancelAnimationFrame(this._gsHowtoFrame);
        this.abort?.abort();
        this.observer?.disconnect();
        this._gsHowtoReady = false;
      }
      motion() {
        return window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      }
      move(direction) {
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const step = this.cards[0].getBoundingClientRect().width + gap;
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        this.track.scrollBy({ left: direction * step * (rtl ? -1 : 1), behavior: this.motion() });
      }
      scheduleUpdate() {
        cancelAnimationFrame(this._gsHowtoFrame);
        this._gsHowtoFrame = requestAnimationFrame(() => this.update());
      }
      update() {
        const maximum = this.track.scrollWidth - this.track.clientWidth;
        const position = Math.abs(this.track.scrollLeft);
        this.controls.hidden = this.dataset.showArrows !== 'true' || maximum < 2;
        this.previous.disabled = position <= 2;
        this.next.disabled = position >= maximum - 2;
        const viewport = this.track.getBoundingClientRect();
        const visible = this.cards.map((card, index) => {
          const rect = card.getBoundingClientRect();
          const middle = rect.left + rect.width / 2;
          return middle >= viewport.left && middle <= viewport.right ? index + 1 : null;
        }).filter(Boolean);
        if (this.count && visible.length) {
          const first = visible[0];
          const last = visible[visible.length - 1];
          this.count.textContent = `${first === last ? first : first + '–' + last} of ${this.cards.length}`;
        }
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["getsnappy-ways-to-wear"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (!window.customElements || customElements.get('gs-silicone-ways')) return;
    customElements.define('gs-silicone-ways', class extends HTMLElement {
      connectedCallback() {
        if (this._gsWaysReady) return;
        const initialize = () => {
          if (!this.isConnected || this._gsWaysReady) return;
          this.track = this.querySelector('.gs-silicone-ways__track');
          if (!this.track) return;
          this.cards = [...this.querySelectorAll('.gs-silicone-ways__card')];
          this.previous = this.querySelector('[data-gs-ways-prev]');
          this.next = this.querySelector('[data-gs-ways-next]');
          this.count = this.querySelector('.gs-silicone-ways__count');
          this.controls = this.querySelector('.gs-silicone-ways__controls');
          if (!this.cards.length || !this.previous || !this.next || !this.controls) return;
          this._gsWaysReady = true;
          this.abort = new AbortController();
          const options = { signal: this.abort.signal };
          this.previous.addEventListener('click', () => this.move(-1), options);
          this.next.addEventListener('click', () => this.move(1), options);
          this.track.addEventListener('keydown', event => {
            if (event.target !== this.track || event.altKey || event.ctrlKey || event.metaKey) return;
            if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
            event.preventDefault();
            const rtl = getComputedStyle(this.track).direction === 'rtl';
            if (event.key === 'Home' || event.key === 'End') {
              this.track.scrollTo({ left: event.key === 'Home' ? 0 : (rtl ? -1 : 1) * this.track.scrollWidth, behavior: this.motion() });
            } else {
              this.move((event.key === 'ArrowRight' ? 1 : -1) * (rtl ? -1 : 1));
            }
          }, options);
          this.addEventListener('shopify:block:select', event => {
            const card = this.cards.find(item => item.dataset.blockId === event.detail?.blockId);
            card?.scrollIntoView({ block: 'nearest', inline: 'start', behavior: 'auto' });
          }, options);
          this.track.addEventListener('scroll', () => this.scheduleUpdate(), { ...options, passive: true });
          if (window.ResizeObserver) {
            this.observer = new ResizeObserver(() => this.scheduleUpdate());
            this.observer.observe(this.track);
          } else {
            window.addEventListener('resize', () => this.scheduleUpdate(), options);
          }
          this.update();
        };
        // A section may be inserted or moved by the Shopify theme editor.
        // Wait for the element's children if this definition was registered earlier.
        this._gsWaysInit = requestAnimationFrame(initialize);
      }
      disconnectedCallback() {
        cancelAnimationFrame(this._gsWaysInit);
        cancelAnimationFrame(this._gsWaysFrame);
        this.abort?.abort();
        this.observer?.disconnect();
        this._gsWaysReady = false;
      }
      motion() {
        return window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      }
      move(direction) {
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const step = this.cards[0].getBoundingClientRect().width + gap;
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        this.track.scrollBy({ left: direction * step * (rtl ? -1 : 1), behavior: this.motion() });
      }
      scheduleUpdate() {
        cancelAnimationFrame(this._gsWaysFrame);
        this._gsWaysFrame = requestAnimationFrame(() => this.update());
      }
      update() {
        const maximum = this.track.scrollWidth - this.track.clientWidth;
        const position = Math.abs(this.track.scrollLeft);
        this.controls.hidden = this.dataset.showArrows !== 'true' || maximum < 2;
        this.previous.disabled = position <= 2;
        this.next.disabled = position >= maximum - 2;
        const viewport = this.track.getBoundingClientRect();
        const visible = this.cards.map((card, index) => {
          const rect = card.getBoundingClientRect();
          const middle = rect.left + rect.width / 2;
          return middle >= viewport.left && middle <= viewport.right ? index + 1 : null;
        }).filter(Boolean);
        if (this.count && visible.length) {
          const first = visible[0];
          const last = visible[visible.length - 1];
          this.count.textContent = `${first === last ? first : first + '–' + last} of ${this.cards.length}`;
        }
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
